import { Injectable } from '@angular/core';
import { Setting } from '../entities/setting';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.development';
import { Observable, catchError, of } from 'rxjs';

interface ApiResponse {
  status: string;
  data: Setting | Setting[];
}

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  constructor(private http: HttpClient) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private settingServiceUrl = this.apiServicesUrl + '/setting';

  getRegistrationNumber(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.settingServiceUrl + '/registration_number')
    .pipe(
      catchError(this.handleError<ApiResponse>('getSettings'))
    );
  }

  getSettingByName(settingName: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.settingServiceUrl + '/' + settingName)
    .pipe(
      catchError(this.handleError<ApiResponse>('getSettings'))
    );
  }

  getSettingLikeName(settingName: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.settingServiceUrl + '-like/' + settingName)
    .pipe(
      catchError(this.handleError<ApiResponse>('getSettings'))
    );
  }
  
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
